import { render, staticRenderFns } from "./remove-dialog.pug?vue&type=template&id=7877afb2&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./remove-dialog.scss?vue&type=style&index=0&id=7877afb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7877afb2",
  null
  
)

export default component.exports